import * as _ from "lodash"
import { ISerializable } from "./ISerializable"
import { OperationStatus } from "./OperationStatus"

class ServiceError implements ISerializable<ServiceError> {
    public static readonly NoDomain = "noDomain"
    public static domainCatalogs: any = {}
    public static defaultCatalog: any = {
        1: "general failure",
        60: "exception",
        61: "invalid arguments",
        62: "not found",
    }

    public static fromJSON(raw: any): ServiceError {
        const r = new ServiceError()
        return r.deserialize(raw)
    }

    public Domain: string
    public ErrorCode: number
    public Message: string
    public ShortMessage: string

    public constructor(
        domain: string = ServiceError.NoDomain,
        errorCode: number = 0,
        message?: string,
        shortMessage?: string
    ) {
        this.Domain = domain
        this.ErrorCode = errorCode
        this.Message = message
        this.ShortMessage = shortMessage
    }

    public deserialize(raw: any): ServiceError {
        _.extend(this, raw)
        if (null == this.Message) {
            this.Message = undefined
        }
        if (null == this.ShortMessage) {
            this.ShortMessage = undefined
        }
        return this
    }

    /**
     * Return a reasonable error message for an operation.
     * @param op
     * @param extraCatalog
     */
    public getErrorMessage(extraCatalog?: any) {
        const catalog = _.extend(
            {},
            ServiceError.defaultCatalog,
            ServiceError.domainCatalogs[this.Domain],
            extraCatalog
        )
        const msg = catalog[this.ErrorCode]
        return msg
            ? msg
            : "An unexpected error has occurred (code: " + this.ErrorCode + ")"
    }

    public get isError(): boolean {
        return 0 !== this.ErrorCode
    }
}

// tslint:disable-next-line:max-classes-per-file
class WebServiceResponse implements ISerializable<WebServiceResponse> {
    public static fromJSON(raw: any): WebServiceResponse {
        const r = new WebServiceResponse()
        return r.deserialize(raw)
    }

    public IsError: boolean
    public Error: ServiceError
    public ExtraInfo: any
    public censusInfo: any

    public constructor() {
        this.Error = new ServiceError()
    }

    public deserialize(raw: any): WebServiceResponse {
        _.extend(this, raw)
        this.Error = ServiceError.fromJSON(raw.Error)
        return this
    }
}

// tslint:disable-next-line:max-classes-per-file
class WebServiceBase {
    public requestOptions(
        uri: string,
        body: any,
        accessToken?: string,
        options?: any
    ) {
        const opts = _.extend(
            {
                method: "POST",
                body: body ? JSON.stringify(body) : undefined,
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
            },
            options
        )
        // tslint:disable-next-line:no-console
        //console.log('opts: ' + JSON.stringify(opts, undefined, 4))
        const req = new Request(uri, opts)
        if (accessToken) {
            req.headers.append("X-TMD-session-token", accessToken)
        }

        return req
    }

    trace(): any {
        return (stuff: Response): Response => {
            // tslint:disable-next-line:no-console
            console.log("trace: " + JSON.stringify(stuff, undefined, 4))
            return stuff
        }
    }
}

function genericFailure(reason: any): OperationStatus {
    const op = new OperationStatus()
    if (reason instanceof WebServiceResponse) {
        op.update(reason)
    } else {
        op.setError(9999, reason.toString())
    }

    return op
}

export { ServiceError, WebServiceResponse, WebServiceBase, genericFailure }



// WEBPACK FOOTER //
// ./src/app/services/WebServiceBase.ts